import { addMinutes, format, parse } from "date-fns";
import { uniq } from "lodash";
import { UseRecordsOptions } from "../../api/useRecords";
import { NFB_WEEKDAY_SLOTS, NFB_SATURDAY_SLOTS, NFB_SLOT_DURATION_MIN } from "../../screens/reserved-slots/constants";

const NFB_START_TIMES = uniq([...NFB_WEEKDAY_SLOTS, ...NFB_SATURDAY_SLOTS]).sort();
const NFB_END_TIMES = NFB_START_TIMES.map((startTime) =>
    format(addMinutes(parse(startTime, "HH:mm", new Date()), NFB_SLOT_DURATION_MIN), "HH:mm")
);

const toTimeChoices = (times: Array<string>) => {
    const timeChoices = times.map((time) => ({ text: time, value: `${time}:00` }));
    return timeChoices;
};

const toDateKey = (dateValue: string | null | undefined) => {
    const dateKey = dateValue ? dateValue.slice(0, 10) : "";
    return dateKey;
};

const validateCapacityBlock = (data: any) => {
    const isEndDateBeforeStart = toDateKey(data.end_date) < toDateKey(data.start_date);
    if (isEndDateBeforeStart) {
        const validation = { valid: false, message: "A data de fim não pode ser anterior à data de início." };
        return validation;
    }

    const isEndTimeNotAfterStart = Boolean(data.start_time && data.end_time) && data.end_time <= data.start_time;
    if (isEndTimeNotAfterStart) {
        const validation = { valid: false, message: "A hora de fim tem de ser posterior à hora de início." };
        return validation;
    }

    const validation = { valid: true };
    return validation;
};

const groupsOptions = {
    fieldsWithExtraOptions: [
        {
            field: "clinic",
            relatedTable: "clinics",
            displayTemplate: "{{name}}",
            enabled: true,
            sort: "id",
        },
        { field: "start_date", settings: { interface: "date" } },
        { field: "end_date", settings: { interface: "date" } },
        {
            field: "start_time",
            settings: { interface: "select-dropdown", display: "text", options: { choices: toTimeChoices(NFB_START_TIMES) } },
        },
        {
            field: "end_time",
            settings: { interface: "select-dropdown", display: "text", options: { choices: toTimeChoices(NFB_END_TIMES) } },
        },
    ],
    isFormValid: validateCapacityBlock,
};

export const clinicsNfbCapacityBlocksOptions = {
    fieldsToRemove: {
        fieldNamesToRemove: ["id"],
        fieldTypesToRemove: ["alias"],
    },
    groupsOptions,
} as unknown as UseRecordsOptions;

export const clinicsNfbCapacityBlocksRecordOptions = {
    groupsOptions,
} as unknown as UseRecordsOptions;
